'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearExistingAgentTypingTimeout = undefined;

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _agentTypingStates = require('../../typing-indicators/selectors/agentTypingStates');

var _getTypingTimeoutIdForAgentInThread = require('../../typing-indicators/operators/getTypingTimeoutIdForAgentInThread');

var clearExistingAgentTypingTimeout = exports.clearExistingAgentTypingTimeout = function clearExistingAgentTypingTimeout(message, threadId) {
  return function (dispatch, getState) {
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);
    var agentTypingStates = (0, _agentTypingStates.agentTypingStates)(getState());

    var existingTimeoutId = (0, _getTypingTimeoutIdForAgentInThread.getTypingTimeoutIdForAgentInThread)({
      threadId: threadId,
      agentId: senderId,
      agentTypingStates: agentTypingStates
    });

    if (typeof existingTimeoutId === 'number') {
      clearTimeout(existingTimeoutId);
    }
  };
};